import { HiverAxios, CreateApiHandler } from 'h-commons'
import { GET_TRIAL_FEATURES, START_TRIAL,CONTACT_US } from "./actionType";

export const getTrialFeaturesActionCreator = CreateApiHandler(({ userGroupId }) => {
  return new Promise((res, rej) => {
    HiverAxios({
      url: `/addons/${userGroupId}/getTrialAddon`,
      type: 'GET',
      callback: (response) => {
        res(response && response.data);
      },
      onfail: rej
    });

  })

}, GET_TRIAL_FEATURES);

export const startTrialActionCreator = CreateApiHandler(({ userGroupId, addonId }) => {
  return new Promise((res, rej) => {
    HiverAxios({
      url: `/addons/${addonId}/startTrial/${userGroupId}`,
      type: 'PUT',
      callback: (response) => {
        res(response && response.data);
      },
      onfail: (response) => {
        rej(response);
      }
    });

  })

}, START_TRIAL);

export const contactUsActionCreator = CreateApiHandler(({feature }) => {
  return new Promise((res, rej) => {
    HiverAxios({
      url: `/addons/${feature}/contactUs`,
      type: 'PUT',
      callback: (response) => {
        res(response && response.data);
      },
      onfail: (response) => {
        rej(response);
      }
    });

  })

}, CONTACT_US);